import { render, staticRenderFns } from "./ed-upload-course-material.vue?vue&type=template&id=543c0bcc&scoped=true&"
import script from "./ed-upload-course-material.ts?vue&type=script&lang=js&"
export * from "./ed-upload-course-material.ts?vue&type=script&lang=js&"
import style0 from "./ed-upload-course-material.scss?vue&type=style&index=0&id=543c0bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543c0bcc",
  null
  
)

export default component.exports